export default "__VITE_ASSET__gTmwZjmk__"